<nav>
  <div class="topMenu py-2 d-none d-sm-none d-md-block shadow bg-body rounded">
    <div class="topMenuBanner ms-md-5" style="width: 200px">
      <a [routerLink]="''">
        <img src="../../../assets/img/LogotipoMasGarantia.svg"/>
      </a>
    </div>
  
    <div class="topMenuItemContainer">
      <div><a class="textToolBar text-muted"> {{ 'MAS_GARANTIA_NAVBAR.LABEL1' | translate }} </a></div>
      <div>
        <div class="popover__wrapper d-none d-sm-none d-md-block">
          <a href="https://miseguro.liverpool.com.mx/?_gl=1*5jfk5*_gcl_au*MjEzMDY3MDA3NC4xNjkxMTA1ODgx&_ga=2.223967902.421766386.1691289467-907072490.1681227841"
            style="font-size:14px;font-weight:normal;cursor:pointer;text-decoration: none;" class="text-muted primary-color">
            {{ 'MAS_GARANTIA_NAVBAR.LABEL2' | translate }} <fa-icon [icon]="faAngleDown" class="fa-solid fa-angle-down"></fa-icon>
          </a>
          <div class="popover__content">
            <div class='container-fluid'>
              <div class='row'>
                <div class="col-12 mb-2">
                  <span><a class='text-decoration-none text-muted '
                      href='https://pif.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL3' | translate }} </a></span>
                </div>
                <div class="col-12 mb-2">
                  <a class='text-decoration-none text-muted mt-1' href='https://cotizadorauto.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL4' | translate }} </a>
                </div>
                <div class="col-12 mb-2">
                  <a class='text-decoration-none text-muted mt-1'
                    href='https://proteccioncelular.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL5' | translate }} </a>
                </div>
                <div class="col-12 mb-2">
                  <a class='text-decoration-none text-muted mt-1' href='https://masgarantia.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL6' | translate }} </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div><a class="textToolBar text-muted" href="https://login.liverpool.com.mx/u/login"> {{ 'MAS_GARANTIA_NAVBAR.LABEL7' | translate }} </a></div>
    </div>
  </div>
  
  <div class="d-block d-sm-block d-md-none sideContainer shadow py-2 bg-body rounded" [ngClass]="{'position-relative': mobileQuery}">
    <div class="w-25 ms-3">
        <button class="h-100" mat-icon-button (click)="toogleMenu()">
            <fa-icon [icon]="faBars" class="fa-solid fa-xl"></fa-icon>
        </button>
    </div>
    <div [ngClass]="{'position-absolute top-50 start-50 translate-middle': mobileQuery}">
      <img src="../../../assets/img/LogotipoMasGarantia.svg"/>
    </div>
  </div>
  <mat-sidenav-container>
      <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
          [(opened)]="openedMenu" fixedTopGap="0">
          <div class="leftMenuContainer">
              <mat-list role="list">
                  <mat-list-item role="listitem" (click)="toogleMenuCenter()"><fa-icon [icon]="faAngleLeft" class="fa-solid"></fa-icon>
                  </mat-list-item>
                  <mat-list-item role="listitem"><a class='text-decoration-none text-muted '
                          href='https://pif.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL3' | translate }} </a></mat-list-item>
                  <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                          href='https://cotizadorauto.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL4' | translate }} </a></mat-list-item>
                  <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                          href='https://proteccioncelular.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL5' | translate }} </a>
                  </mat-list-item>
                  <mat-list-item role="listitem"><a class='text-decoration-none text-muted mt-1'
                          href='https://masgarantia.liverpool.com.mx/'> {{ 'MAS_GARANTIA_NAVBAR.LABEL6' | translate }} </a></mat-list-item>
  
              </mat-list>
          </div>
      </mat-sidenav>
  
      <mat-sidenav-content>
          <mat-sidenav-container>
              <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'"
                  [fixedInViewport]="mobileQuery.matches" [(opened)]="opened" fixedTopGap="56">
                  <div class="leftMenuContainer">
                      <mat-list role="list">
                          <mat-list-item role="listitem" >{{this.storageService.getData('userName')}}</mat-list-item>
                          <mat-divider></mat-divider>
                          <mat-list-item role="listitem"> {{ 'MAS_GARANTIA_NAVBAR.LABEL1' | translate }} </mat-list-item>
                          <mat-list-item role="listitem" (click)="toogleMenuCenter()">
                              <span style="font-weight: 500;" class="primary-color"> {{ 'MAS_GARANTIA_NAVBAR.LABEL8' | translate }} </span> <fa-icon [icon]="faAngleRight"
                                  class="fa-solid" style="margin-left: 10px;"></fa-icon>
                          </mat-list-item>
                          <mat-list-item role="listitem">
                              <a class='text-decoration-none text-reset'
                                  href="https://miseguro.liverpool.com.mx/mis-polizas"> {{ 'MAS_GARANTIA_NAVBAR.LABEL7' | translate }} </a>
                          </mat-list-item>
                          <mat-list-item role="listitem"> {{ 'MAS_GARANTIA_NAVBAR.LABEL9' | translate }} </mat-list-item>
  
                      </mat-list>
                  </div>
              </mat-sidenav>
              <mat-sidenav-content>
                <ng-content>

                </ng-content>
              </mat-sidenav-content>
          </mat-sidenav-container>
      </mat-sidenav-content>
  </mat-sidenav-container>
</nav>